/**
 * v3 Suspense fallback (B-shell-3b) — shown only while the lazily-loaded V3Page
 * chunk downloads. Imports tokens.css itself so the .mos-v3 design variables
 * resolve during the flash (V3Page's own tokens.css hasn't loaded yet). No
 * animation → deterministic; the harness waits for the real table, so this is
 * never captured in a baseline. Calm, neutral, colour-token only.
 */
import './tokens.css';

export function V3Loading(): JSX.Element {
  return (
    <div
      className="mos-v3"
      data-testid="v3-loading"
      role="status"
      aria-busy="true"
      aria-label="Loading terminal"
      style={{
        height: '100vh',
        width: '100vw',
        background: 'var(--bg-deep)',
        color: 'var(--muted)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace',
        fontSize: 'var(--fs-sm)',
      }}
    >
      <span aria-hidden style={{ color: 'var(--cyan)', fontSize: '16px', lineHeight: 1 }}>⬡</span>
      Loading…
    </div>
  );
}
